import styled from 'styled-components';

export const NavbarSindicoCenter = styled.div`
  width: 1172px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

export const NavbarContainerItems = styled.div`
  display: flex;
  flex-direction: ${({ dir }) => (dir === 'column' ? 'column' : 'row')};
  gap: 24px;
  align-items: ${({ dir }) => (dir === 'column' ? 'left' : 'center')};
`;

export const MenuItem = styled.span`
  color: ${({ isActive }) => (isActive ? '#003DA5' : '#4d4d4d')};
  font-weight: ${({ isActive }) => (isActive ? '500' : '400')};
  letter-spacing: 0.002em;
  text-transform: uppercase;
  text-align: left;

  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`;
